import { array, number, object, string } from "zod";

export const serviceDetailsSchema = object({
  attributes: array(
    object({
      attributeId: string(),
      quantity: number().nullable().optional(),
      valueId: array(string()),
    }).nullable(),
  ),
  paymentMethodId: string().nullable().optional(),
  services: array(
    object({
      serviceId: string(),
      variants: array(
        object({
          quantity: number(),
          variantId: string(),
        }),
      ),
    }).nullable(),
  ),
  startDate: string().nullable().optional(),
});
